require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("./Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SideAds = function SideAds(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 2 : _ref$count,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 40 : _ref$marginBottom,
      adHeights = _ref.adHeights;
  var sizes = [200, 250, 600];

  if (adHeights) {
    return adHeights.map(function (height) {
      return _react["default"].createElement(_Box["default"], {
        key: height,
        height: height,
        mb: marginBottom
      });
    });
  }

  return Array.from(Array(count), function (e, i) {
    var height = sizes[Math.floor(Math.random() * sizes.length)];
    return _react["default"].createElement(_Box["default"], {
      key: i,
      height: height,
      mb: marginBottom
    });
  });
};

var _default = SideAds;
exports["default"] = _default;